/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_Remove_Marker_ButtonInputs */

const en_markers_remove_marker_button = /** @type {(inputs: Markers_Remove_Marker_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove`)
};

const fr_markers_remove_marker_button = /** @type {(inputs: Markers_Remove_Marker_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer`)
};

const de_markers_remove_marker_button = /** @type {(inputs: Markers_Remove_Marker_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entfernen`)
};

const it_markers_remove_marker_button = /** @type {(inputs: Markers_Remove_Marker_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimuovere`)
};

const ru_markers_remove_marker_button = /** @type {(inputs: Markers_Remove_Marker_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалять`)
};

const es_markers_remove_marker_button = /** @type {(inputs: Markers_Remove_Marker_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar`)
};

const zh_cn2_markers_remove_marker_button = /** @type {(inputs: Markers_Remove_Marker_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`消除`)
};

const ja_markers_remove_marker_button = /** @type {(inputs: Markers_Remove_Marker_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取り除く`)
};

const hi_markers_remove_marker_button = /** @type {(inputs: Markers_Remove_Marker_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निकालना`)
};

const pt_pt2_markers_remove_marker_button = /** @type {(inputs: Markers_Remove_Marker_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remover`)
};

/**
* | output |
* | --- |
* | "Remove" |
*
* @param {Markers_Remove_Marker_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_remove_marker_button = /** @type {((inputs?: Markers_Remove_Marker_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_Remove_Marker_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_markers_remove_marker_button(inputs)
	if (locale === "de") return de_markers_remove_marker_button(inputs)
	if (locale === "it") return it_markers_remove_marker_button(inputs)
	if (locale === "ru") return ru_markers_remove_marker_button(inputs)
	if (locale === "es") return es_markers_remove_marker_button(inputs)
	if (locale === "zh-CN") return zh_cn2_markers_remove_marker_button(inputs)
	if (locale === "ja") return ja_markers_remove_marker_button(inputs)
	if (locale === "hi") return hi_markers_remove_marker_button(inputs)
	if (locale === "pt-PT") return pt_pt2_markers_remove_marker_button(inputs)
	return en_markers_remove_marker_button(inputs)
});